export const coveredDirectorySlugs = (
  towns: readonly {
    slug?: string | null;
    directoryAreaSlug?: string | null;
  }[],
) => {
  const slugs = new Set<string>();

  for (const town of towns) {
    if (town.slug) {
      slugs.add(town.slug);
    }
    if (town.directoryAreaSlug) {
      slugs.add(town.directoryAreaSlug);
    }
  }

  return slugs;
};
